import React from 'react';

import logo from '../../../../assets/icon/logo.svg';
import ui from '../../../../styles/ui.module.css';
import st from './Footer.module.css';
import {Link} from "react-router-dom";

export function Footer({ onTop, onProgram }) {
  return (
    <footer className={st.footer}>
      <div className={`${ui.container} ${st.inner}`}>
        <div className={st.left}>
          <div className={st.brand}>
            <img className={ui.brandLogo} src={logo} alt="" aria-hidden="true" />
          </div>
          <div className={st.copy}>© {new Date().getFullYear()} — учебный лендинг. Все права защищены.</div>
        </div>
        <div className={st.right}>
          <button className={`${ui.link} ${ui.linkMuted}`} onClick={onTop} type="button">
            Наверх
          </button>
          <span className={st.sep} aria-hidden="true">
            ·
          </span>
          <button className={`${ui.link} ${ui.linkMuted}`} onClick={onProgram} type="button">
            Программа
          </button>
          <span className={st.sep} aria-hidden="true">
            ·
          </span>
          <Link to={'https://rsmu.ru'} className={`${ui.link} ${ui.linkMuted}`}>
            ФГАУО ВО РНИМУ им. Н.И. Пирогова (Пироговский Университет)
          </Link>
        </div>
      </div>
    </footer>
  );
}

